/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_NOTIFICATION_TYPES = gql`
  query GetNotificationTypes {
    notificationTypes {
      name
      validChannels
      canOptOut
    }
  }
`
